import React from 'react'
import { Statement } from '@Entities/statements/statement'
import { formatUSD } from '@App/helpers/format-currency'
import { v4 as uuidv4 } from 'uuid'
import { observer } from 'mobx-react'
import '../index.scss'

interface StatementsTableProps {
    selectedRows: string[]
    toggleAll: () => void
    rows: Statement[]
    toggleChecked: (id: string) => void
}

const StatementsTable = (props: StatementsTableProps) => {
    const { selectedRows, toggleAll, rows, toggleChecked } = props
    const itemsChecked = !!selectedRows.length

    return (
        <div className="royalties-table">
            <table>
                <tbody>
                    <tr>
                        <th className="index-white">Payee</th>
                        <th className="index-white">DSP</th>
                        <th className="index-white">Distribution Period</th>
                        <th className="index-white">Amount</th>
                        <th className="index-white" onClick={toggleAll}>
                            {itemsChecked ? 'Deselect All' : 'Select All'}
                        </th>
                    </tr>
                    {rows.length > 0 &&
                        rows.map((row: Statement) => (
                            <tr key={uuidv4()}>
                                <td>{row.payee}</td>
                                <td>{row.dsp}</td>
                                <td>
                                    {Intl.DateTimeFormat('en', { month: 'long', year: 'numeric' }).format(
                                        new Date(row.year, row.month - 1)
                                    )}
                                </td>
                                <td>
                                    <div className="currency">
                                        <p>{formatUSD(row.amount)}</p>
                                    </div>
                                </td>
                                <td>
                                    <div className="select">
                                        <input
                                            type="checkbox"
                                            defaultChecked={selectedRows.includes(row.id)}
                                            onChange={(event) => toggleChecked(row.id)}
                                        />
                                    </div>
                                </td>
                            </tr>
                        ))}
                    {rows.length === 0 && (
                        <tr key={uuidv4()}>
                            <td colSpan={5}>
                                No statement is available as no usage activity was reported for this time period. Please
                                note that it takes about three payment cycles for newly submitted works data to make an
                                impact on your statements.
                            </td>
                        </tr>
                    )}
                </tbody>
            </table>
        </div>
    )
}

export default observer(StatementsTable)
